import { DepartmentService } from '@/services/department.service';
import { queryOptions } from '@tanstack/react-query';

export const listDepartmentsQuery = queryOptions({
  queryKey: ['list-departments'],
  queryFn: DepartmentService.list,
});

export const listDepartmentsWithRelationsQuery = queryOptions({
  queryKey: ['list-departments-with-relations'],
  queryFn: DepartmentService.listWithRelationsCount,
});
